import React from 'react'
import Link from 'gatsby-link'
import styles from './Header.module.css'

const Header = ({ siteTitle }) => (
  <div className={styles.Header}>
    <h1 style={{ margin: 0 }}>
      <Link to="/">{siteTitle}</Link>
    </h1>
  </div>
)

export default Header



// WEBPACK FOOTER //
// ./src/components/Header/Header.js